export function calculateFrostedWindowArea(width, height) {
  if (String(width).trim() === '' || String(height).trim() === '') return null;
  const w = Number(width), h = Number(height), area = w * h / 1000000;
  return Number.isFinite(w) && Number.isFinite(h) && w > 0 && h > 0 && Number.isFinite(area) && area > 0 ? area : null;
}
export function frostedDimensionError(width, height) {
  const area = calculateFrostedWindowArea(width, height), w = Number(width), h = Number(height);
  if (w > 1250) return 'width';
  if (h > 5000) return 'height';
  if (area > 6.5) return 'area';
  if (area === null || w < 100 || h < 100) return 'range';
  return null;
}
const bands = [
  [0.5, 'Up to 0.5 m²'], [1, 'Over 0.5–1.0 m²'], [1.5, 'Over 1.0–1.5 m²'],
  [2.25, 'Over 1.5–2.25 m²'], [3.25, 'Over 2.25–3.25 m²'],
  [4.5, 'Over 3.25–4.5 m²'], [6.5, 'Over 4.5–6.5 m²']
];
export function resolveApprovedFrostedWindowVariant(variants, type, area) {
  if (!Number.isFinite(area) || area <= 0 || area > 6.5) return null;
  const band = bands.find(([limit]) => area <= limit)?.[1];
  const matches = variants.filter(v => v.options.length === 2 && v.options[0] === type && v.options[1] === band && v.price_cents > 0);
  return matches.length === 1 ? matches[0] : null;
}
export function includesApprovedFrostedWindowSqueegee(area) {
  return Number.isFinite(area) && area >= 0.35;
}
if (typeof customElements !== 'undefined' && !customElements.get('frosted-window-order')) {
  customElements.define('frosted-window-order', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('form');
      this.variants = JSON.parse(this.querySelector('[data-frosted-variants]').textContent);
      this.type = this.querySelector('[data-frosted-type]');
      this.details = this.querySelector('[data-frosted-details]');
      this.artwork = this.querySelector('[data-frosted-artwork]');
      this.width = this.querySelector('[data-frosted-width]');
      this.height = this.querySelector('[data-frosted-height]');
      this.idInput = this.form.querySelector('[name="id"]');
      this.button = this.form.querySelector('[name="add"]');
      this.price = this.querySelector('[data-frosted-price]');
      this.addEventListener('input', () => this.update());
      this.addEventListener('change', () => this.update());
      this.addEventListener('submit', event => {
        this.validateDetails();
        const area = this.area(), variant = resolveApprovedFrostedWindowVariant(this.variants, this.type.value, area);
        const areaProperty = this.querySelector('[data-frosted-area-property]');
        const valid = !frostedDimensionError(this.width.value, this.height.value) && variant?.available && this.form.checkValidity() && !this.idInput.disabled && this.idInput.value === String(variant.id) && this.price.textContent === variant.price && areaProperty.value === `${area} m²`;
        if (!valid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.update();
          this.form.reportValidity();
        }
      }, true);
      this.observer = new MutationObserver(() => {
        const variant = resolveApprovedFrostedWindowVariant(this.variants, this.type.value, this.area());
        if ((frostedDimensionError(this.width.value, this.height.value) || !variant?.available || !this.form.checkValidity() || this.idInput.value !== String(variant.id) || this.price.textContent !== variant.price) && !this.button.disabled) this.button.disabled = true;
      });
      this.observer.observe(this.button, { attributes: true, attributeFilter: ['disabled'] });
      this.update();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
    validateDetails() { this.details.setCustomValidity(this.details.required && !this.details.value.trim() ? this.dataset.required : ''); }
    area() { return calculateFrostedWindowArea(this.width.value, this.height.value); }
    update() {
      this.button.disabled = true;
      this.idInput.value = '';
      this.idInput.disabled = true;
      this.price.textContent = this.dataset.pricePrompt;
      for (const field of [this.width, this.height]) field.setCustomValidity(field.value && Number.isFinite(field.valueAsNumber) && field.valueAsNumber > 0 ? '' : this.dataset.invalidDimensions);
      const area = this.area();
      this.querySelector('[data-frosted-area]').textContent = area === null ? '—' : `${area < 0.01 ? '<0.01' : area.toFixed(2)} m²`;
      const property = this.querySelector('[data-frosted-area-property]');
      property.value = area === null ? '' : `${area} m²`;
      property.disabled = area === null;
      const custom = ['Cut-out Lettering / Logo', 'Frosted Lettering / Logo'].includes(this.type.value);
      this.querySelector('[data-frosted-custom]').hidden = !custom;
      this.details.disabled = !custom;
      this.details.required = custom;
      this.artwork.disabled = !custom;
      this.validateDetails();
      this.querySelector('[data-frosted-squeegee]').hidden = !includesApprovedFrostedWindowSqueegee(area);
      const warning = this.querySelector('[data-frosted-warning]');
      const dimensionError = frostedDimensionError(this.width.value, this.height.value);
      const dimensionsComplete = this.width.value.trim() !== '' && this.height.value.trim() !== '';
      warning.hidden = !dimensionsComplete || !dimensionError;
      this.querySelector('[data-frosted-warning-text]').textContent = dimensionError ? this.dataset['warning' + dimensionError[0].toUpperCase() + dimensionError.slice(1)] : '';
      const message = this.querySelector('[data-frosted-message]');
      message.textContent = '';
      message.hidden = true;
      if (!dimensionsComplete || dimensionError) return;
      const variant = resolveApprovedFrostedWindowVariant(this.variants, this.type.value, area);
      if (!variant) return;
      this.price.textContent = variant.price;
      this.idInput.value = String(variant.id);
      this.idInput.disabled = false;
      this.button.disabled = !variant.available || !this.form.checkValidity();
      if (!variant.available) { message.textContent = this.dataset.unavailable; message.hidden = false; }
    }
  });
}
